// extracted by mini-css-extract-plugin
module.exports = {"m126aln0":"m126aln0","bw0i50u":"bw0i50u","b1k6yajz":"b1k6yajz","fi083yl":"fi083yl"};